import React from "react";
import { NavLink as RouterNavLink, useLocation } from "react-router-dom";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UncontrolledTooltip, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledButtonDropdown } from "reactstrap";

const DealerNav = ({ path }) => {
    let location = useLocation();
    const [color, setColor] = React.useState(color);

    React.useEffect(() => {
        const newColor =
            window.location.pathname.includes(path) ||
                window.location.pathname === "/tenant"
                ? "primary"
                : "secondary";
        //console.log(window.location.pathname);
        setColor(newColor);
    }, [location]);

    return (
        <UncontrolledButtonDropdown>
            <DropdownToggle color={color} id="tenantDDNavBtn" caret>
                <FontAwesomeIcon icon="university" />
            </DropdownToggle>
            <UncontrolledTooltip placement="auto" popperClassName="tooltip-primary" target="tenantDDNavBtn">
                Gestione Dealer
            </UncontrolledTooltip>
            <DropdownMenu>

                <Can
                    roles={[roles.DEALER, roles.VENDITORE, roles.ADMIN, roles.AGENTE]}
                    yes={() => (
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/dashboard`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="tachometer-alt" className="mr-1" /> Dashboard
                        </DropdownItem>
                    )}
                    no={() => null}
                />

                <Can
                    roles={[roles.DEALER, roles.BACKOFFICE, roles.ADMIN, roles.AGENTE, roles.VENDITORE, roles.MARKETING]}
                    yes={() => (
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/sales`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="hand-holding-usd" className="mr-1" /> Vendite
                        </DropdownItem>
                    )}
                    no={() => null}
                />

                <Can
                    roles={[roles.DEALER, roles.BACKOFFICE, roles.ADMIN, roles.AGENTE]}
                    yes={() => (
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/orders`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="truck" className="mr-1" /> Ordini
                        </DropdownItem>
                    )}
                    no={() => null}
                />

                <Can
                    roles={[roles.DEALER, roles.BACKOFFICE, roles.ADMIN, roles.SERVICE, roles.MARKETING, roles.VENDITORE]}
                    yes={() => (
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/customers`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="users" className="mr-1" /> Clienti
                        </DropdownItem>
                    )}
                    no={() => null}
                />

                <Can
                    roles={[roles.DEALER, roles.BACKOFFICE, roles.ADMIN, roles.AGENTE]}
                    yes={() => (
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/storage`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="warehouse" className="mr-1" /> Magazzino
                        </DropdownItem>
                    )}
                    no={() => null}
                />

                <Can
                    roles={[roles.ADMIN]}
                    yes={() => (
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/products`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="align-center" className="mr-1" /> Prodotti
                        </DropdownItem>
                    )}
                    no={() => null}
                />

                <Can
                    roles={[roles.DEALER, roles.SERVICE, roles.ADMIN]}
                    yes={() => (
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/services`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="wrench" className="mr-1" /> Modelli Tagliando
                        </DropdownItem>
                    )}
                    no={() => null}
                />

                <Can
                    roles={[roles.DEALER, roles.SERVICE, roles.ADMIN]}
                    yes={() => (
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/service-notifications`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="tools" className="mr-1" /> Gestione Richiami
                        </DropdownItem>
                    )}
                    no={() => null}
                />

                <Can
                    roles={[roles.DEALER, roles.ADMIN, roles.MARKETING]}
                    yes={() => (
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/marketing`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="mail-bulk" className="mr-1" /> Campagne Marketing
                        </DropdownItem>
                    )}
                    no={() => null}
                />

                <Can
                    roles={[roles.AGENTE, roles.VENDITORE, roles.BACKOFFICE, roles.SERVICE, roles.MARKETING, roles.DEALER, roles.ADMIN]}
                    yes={() => (
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/structure`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="sitemap" className="mr-1" /> Struttura
                        </DropdownItem>
                    )}
                    no={() => null}
                />

            </DropdownMenu>
        </UncontrolledButtonDropdown>
    );
};

export default DealerNav;
